import { MemberGroups } from "shared-types";
import { getUserGroup } from "../services/authorization";

export function checkIsSearchOnlyCD() {
  return getUserGroup() === MemberGroups.searchOnlyCD;
}
